import React from "react";

const GameHeading = (props) => {
    return(
        <h2 className="game-container__heading">{props.title}</h2> 
    );
};

export default GameHeading;